import { IReqQRCode } from 'src/types/api/qrCodeTypes';
import {
  IReqTmarkRightsPage,
  IResTmarkRightsDetail,
  IResTmarkRightsPage,
} from 'src/types/api/trademarkRightsApiTypes';
import { Api } from '../config';

export const tmarkRightsServiceProvider = () => {
  /**
   * 查詢專利權狀態異動資料。
   */
  const getTmarkRights = async (params?: IReqTmarkRightsPage) => {
    const res = await Api().get('/TmarkRights/search', {
      params: params,
    });
    return res.data as IResTmarkRightsPage;
  };

  /**
   * 查詢專利權狀態異動資料明細。
   */
  const getTmarkRightsByExamNo = async (examNo: string, tmarkClass: string, qrCode: IReqQRCode) => {
    const params = {
      examNo: examNo,
      tmarkClass: tmarkClass,
      qrCode: qrCode.qrCode,
      dataNo: qrCode.dataNo,
      dataClass: qrCode.dataClass,
      uuid: qrCode.uuid,
    };
    const res = await Api().get(`/TmarkRights/search/detail`, {
      params,
    });
    return res.data as IResTmarkRightsDetail;
  };

  return {
    getTmarkRights,
    getTmarkRightsByExamNo,
  };
};
